import { FC, useState } from 'react'

import { useAtomValue, useSetAtom } from 'jotai'

import { Button } from '@sequencehq/core-components'

import { TaskOutcome } from '../../types'
import { ModalEmailApprovalResponse } from './emailApprovalResponse.modal'
import {
  hasValidationErrorsAtom,
  showValidationErrorsAtom
} from './emailReview.atoms'

export const SendReminderButton: FC<{
  completeTask: (outcome: TaskOutcome) => Promise<boolean>
}> = ({ completeTask }) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const hasValidationErrors = useAtomValue(hasValidationErrorsAtom)
  const setShowValidationErrors = useSetAtom(showValidationErrorsAtom)

  const handleClick = () => {
    if (hasValidationErrors) {
      setShowValidationErrors(true)
      return
    }

    setShowModal(true)
  }

  return (
    <>
      <Button
        variant="primary"
        data-testid="watchtower.reviewEmail.sendReminder"
        onClick={handleClick}
      >
        Send reminder
      </Button>
      {showModal && (
        <ModalEmailApprovalResponse
          onClose={() => setShowModal(false)}
          completeTask={completeTask}
        />
      )}
    </>
  )
}
